module.exports = __webpack_public_path__ + "f79aea18f795b4582966d7d8d655de2d.png";